import Vue from 'vue'
import moment from 'moment'
import injector from 'vue-inject'
import { playDoorbell } from '@/service/audioPlayer'

const storeSetting = injector.get('storeSetting')

function compare (a, comparator, b) {
  function compareMoment (momentA, comparator, momentB) {
    switch (comparator) {
      case '>': return momentA.isAfter(momentB)
      case '<': return momentA.isBefore(momentB)
      case '=': return momentA.isSame(momentB)
      case '<=': return momentA.isSameOrBefore(momentB)
      case '>=': return momentA.isSameOrAfter(momentB)
      case '!=': return momentA.isAfter(momentB) || momentA.isBefore(momentB)
      default: return momentA.isSame(momentB)
    }
  }

  function compareNumber (a, comparator, b) {
    switch (comparator) {
      case '>': return a > b
      case '<': return a < b
      case '=': return a === b
      case '<=': return a <= b
      case '>=': return a >= b
      case '!=': return a !== b
      default: return a === b
    }
  }

  const isoStringRegex = /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$/
  return isoStringRegex.test(a) && isoStringRegex.test(b) ? compareMoment(moment(a), comparator, moment(b)) : compareNumber(a, comparator, b)
}

function compareInOrder (subject, currentElement, conditionList) {
  for (const [prop, listOrder, value] of conditionList) {
    if (subject[prop] !== currentElement[prop]) {
      switch (listOrder) {
        case 'ASC': return compare(subject[prop], '<', currentElement[prop])
        case 'DESC': return compare(subject[prop], '>', currentElement[prop])
        case 'EQ_FIRST': return compare(subject[prop], '=', value)
        case 'EQ_LAST': return compare(subject[prop], '!=', value)
      }
    }
  }
  return true
}

export function satisfyFilterCondition (order, conditions) {
  if (order.deletedAt) { return false }
  // conditions 是 undefined 代表這個 filterConfig 不做前端二次過濾，篩選完全由後端負責
  // （關鍵字搜尋就是這種）。舊版直接 conditions.reduce，於是搜尋期間只要收到一筆
  // websocket 訂單更新（UPDATE_ORDER_FROM_SERVER → insertOrder）就會丟 TypeError。
  if (!conditions) { return true }
  // 只要滿足其中一個 condition 就可以留下來
  return conditions.reduce((result, complexConditions) => {
    const condition = {}
    const compares = complexConditions._compares || []
    const nulls = complexConditions._nulls || []
    const notNulls = complexConditions._notNulls || []
    Object.keys(complexConditions).forEach(k => {
      if (k !== '_compares' && k !== '_nulls' && k !== '_notNulls') { condition[k] = complexConditions[k] }
    })
    return result ||
      (Object.keys(condition).reduce((r, key) => r && order[key] === condition[key], true) &&
        compares.reduce((r, c) => r && compare(order[c[0]], c[1], c[2]), true) &&
        nulls.reduce((r, key) => r && !order[key], true) &&
        notNulls.reduce((r, key) => r && order[key], true) &&
        !(storeSetting.store.shouldPreOrderPrePaid && order.diningPreference === 'preOrder' && !order.paidAt))
  }, false)
}

export function insertOrder (orderList, order, filterConfig, ring) {
  const orderIndex = orderList.findIndex(o => o.id === order.id)
  // update
  if (orderIndex !== -1) {
    if (!satisfyFilterCondition(order, filterConfig.conditions)) {
      Vue.delete(orderList, orderIndex)
    } else {
      Vue.set(orderList, orderIndex, order)
    }
  } else if (satisfyFilterCondition(order, filterConfig.conditions)) {
    const index = orderList.findIndex(o => compareInOrder(order, o, filterConfig.orderBy || [['receivedAt', 'ASC']]))
    orderList.splice(index === -1 ? orderList.length : index, 0, order)
    playDoorbell(false)
  }
}

export function isValidNewOrder (order) {
  // 如果是預約外帶而且要預先付款但是還沒有付款，回傳 false
  if (storeSetting.store.shouldPreOrderPrePaid && order.diningPreference === 'preOrder' && !order.paidAt) return false
  return true
}
